<template>
    <Menu ref="sideMenu" theme="dark" width="auto" :open-names="openNames" :active-name="$route.name" @on-select="changeMenu">
        <li class="ivu-menu-item" @click.stop="clickCollapse" style="text-align: center;">
          <i class="ivu-icon ivu-icon-ios-options" style="margin-right: 3px;"></i>
            收起侧边栏
        </li>
        <Submenu v-for="menuItem in menuLists" :name="menuItem.name" :key="menuItem.name">
            <template slot="title">
                <Icon :type="menuItem.icon"></Icon>
                {{menuItem.title}}
            </template>
            <MenuItem v-for="subMenuItem in menuItem.children" :name="subMenuItem.name" :key="subMenuItem.title">
                <Icon :type="subMenuItem.icon"></Icon>
                {{subMenuItem.title}}
            </MenuItem>
        </Submenu>
    </Menu>
</template>

<script>
export default {
  props: {
    menuLists: {
      type: Array
    },

    openNames: {
      type: Array
    }
  },

  methods: {
    changeMenu(name) {
      this.$router.push({
        name
      });
    },
    clickCollapse () {
      this.$emit('changeSQ', false);
    }
  },

  updated() {
    this.$nextTick(() => {
      if (this.$refs.sideMenu) {
        this.$refs.sideMenu.updateOpened(); // 手动更新展开的子目录，注意要在 $nextTick 里调用 （iView API）
        this.$refs.sideMenu.updateActiveName(); // 手动更新当前选择项，注意要在 $nextTick 里调用（iView API）
      }
    });
  }
};
</script>

<style lang="scss">
@import "../../resources/scss/sidebar-menu/menu";
.close-action {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar-menu/sidebar-menu.vue